class OrgJobPathService {
    /**
     * @param {string} orgJobPath
     * @param {number} length
     * @returns {string}
    */
    getDefinedLengthOrgJobPath(orgJobPath, length) {
        const locationSplit = orgJobPath.split('/');
        let shorterOrgJobPath = '';
        let locationCountToCheck = 1;
        let orgJobPathToCheck = locationSplit.slice(-locationCountToCheck).join('/');

        do {
            shorterOrgJobPath = orgJobPathToCheck;
            locationCountToCheck++;
            orgJobPathToCheck = locationSplit.slice(-locationCountToCheck).join('/');
        } while (orgJobPathToCheck.length < length);
        return shorterOrgJobPath;
    }

    /**
     * @param {string} orgJobPath
     * @returns {string}
     */
    getShortShiftOrgJobPath(orgJobPath) {
        const orgJobSplit = orgJobPath.split('/');
        return `.../${orgJobSplit.length >= 3
            ? orgJobSplit.slice(-3).join('/')
            : orgJobPath}`;
    }
}

export default new OrgJobPathService();
